/**
 * Helpers de exibição de campos do paciente no prontuário/checklist.
 */

export function formatPatientBirthPlace(
  birthPlace?: string | null,
): string {
  const value = String(birthPlace || '').trim();
  return value || 'Não informada';
}

export function formatPatientNationality(
  isBrazilian?: boolean | null,
  country?: string | null,
): string {
  if (isBrazilian === true) return 'Brasileiro(a)';
  if (isBrazilian === false) return country || 'Estrangeiro(a)';
  return 'Não informada';
}
